import TMmiddleDectail from './TMmiddleDectail'
export default [
    {
        name: 'tmzjAll',
        path: 'tmzjAll',
        component: () => import('@/pages/BigData/TrademarkModule/TMmiddleCaseFiling/tmzjAll'),
        meta: { title: '全部' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'tmzjPendingDeclaration',
        path: 'tmzjPendingDeclaration',
        component: () => import('@/pages/BigData/TrademarkModule/TMmiddleCaseFiling/tmzjPendingDeclaration'),
        meta: { title: '待申报' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'tmzjDeclaring',
        path: 'tmzjDeclaring',
        component: () => import('@/pages/BigData/TrademarkModule/TMmiddleCaseFiling/tmzjDeclaring'),
        meta: { title: '申报中' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'tmzjDeclared',
        path: 'tmzjDeclared',
        component: () => import('@/pages/BigData/TrademarkModule/TMmiddleCaseFiling/tmzjDeclared'),
        meta: { title: '已申报' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'TMmiddleDectail',
        path: 'TMmiddleDectail',
        redirect: { name: 'tShenBaoCaiLiao' },
        component: () => import('@/pages/BigData/TrademarkModule/TMmiddleDectail'),
        meta: { title: '详情' },
        props(route) {
            return {
                id: route.query.id
            }
        },
        children: [...TMmiddleDectail]
    },
]